import { Animation, AnimationController } from '@ionic/angular';

export const fadePageTransition = (_: HTMLElement, opts: any): Animation => {
  const animationCtrl = new AnimationController();
  const rootTransition = animationCtrl.create();

  const enteringPage = animationCtrl
    .create()
    .addElement(opts.enteringEl)
    .duration(300)
    .easing('ease-in-out')
    .fromTo('opacity', 0, 1);

  const animations: Animation[] = [enteringPage];

  if (opts.leavingEl) {
    const leavingPage = animationCtrl
      .create()
      .addElement(opts.leavingEl)
      .duration(300)
      .easing('ease-in-out')
      .fromTo('opacity', 1, 0);
    
    animations.push(leavingPage);
  }

  rootTransition.addAnimation(animations);

  return rootTransition;
};
